(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("photo-switching", [], factory);
	else if(typeof exports === 'object')
		exports["photo-switching"] = factory();
	else
		root["photo-switching"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'photoSwitching',
    props: {
        photos: {
            type: Array,
            default: []
        }
    },
    data: function data() {
        return {
            currTotal: [], //保存当前请求临时数组
            curr: [],
            startIdx: 0,
            containerW: 0,

            // touchs
            startX: 0,
            currX: 0,
            moveDisX: 0,

            angle: 0,
            turnOpacity: 1,

            scale: .9,
            opacity: 1,

            // circle 参数
            cirScale: .1,
            cirOpacity: 0,
            cirXDis: 0,

            frontStyle: {
                zIndex: 1,
                transform: '',
                opacity: 1
            },
            backStyle: {
                zIndex: 0,
                transformOrigin: '50% 50%',
                transform: 'scale3d(.9, .9, 1)'
            },
            lCircleSty: {
                opacity: 0,
                transform: 'scale3d(.1, .1, 1) translate3d(-50%, 0, 0)',
                left: 0
            },
            rCircleSty: {
                opacity: 0,
                transform: 'scale3d(.1, .1, 1) translate3d(50%, 0, 0)',
                right: 0
            },

            isTouch: false,
            isTurnPhoto: false,

            //side circle
            circleVisible: 'left'
        };
    },
    mounted: function mounted() {
        // 获取容器宽度
        this.containerW = this.$refs.photoSC.clientWidth;

        this._winResized();

        this.currTotal = this.photos;

        if (this.currTotal.length == 0) {
            //组件初始化判断
            this.curr = [{
                isLoading: true,
                isloadingBack: false,
                zIndex: 1
            }, {
                isLoading: false,
                isloadingBack: true,
                zIndex: 0
            }];
        } else if (this.currTotal.length == 1) {
            this.curr.push(this.currTotal[0]);
            this.curr[0].zIndex = 1;
            this.curr[0].isloadingBack = false;
            var obj = {
                isLoading: true,
                isloadingBack: false,
                zIndex: 0
            };
            this.curr.push(obj);
            this.startIdx = 1;
        } else if (this.currTotal.length >= 2) {
            for (var i = 0; i < 2; i++) {
                this.currTotal[this.startIdx + i].zIndex = 1 - i;
                this.currTotal[this.startIdx + i].isloadingBack = false;
                this.curr.push(this.currTotal[this.startIdx + i]);
            };
            this.startIdx = 2;
        }
    },

    watch: {
        photos: function photos(val, oldVal) {
            //判断数组是否刷新
            if (this.curr[0].isLoading) {
                if (val.length >= 2) {
                    var arr = [];
                    for (var i = 0; i < 2; i++) {
                        val[i].zIndex = 1 - i;
                        val[i].isloadingBack = false;
                        arr.push(val[i]);
                    };
                    this.curr = arr;
                    this.startIdx = 2;
                } else if (val.length == 1) {
                    this.curr = [];
                    this.curr.push(val[0]);
                    this.curr[0].zIndex = 1;
                    this.curr[0].isloadingBack = false;
                    var obj = {
                        isLoading: true,
                        isloadingBack: false,
                        zIndex: 0
                    };
                    this.curr.push(obj);
                    this.startIdx = 1;
                } else if (val.length == 0) {
                    this.startIdx = 0;
                }
            } else if (this.curr[1].isLoading) {
                if (val.length > 0) {
                    this.curr.splice(1, 1);
                    this.curr[1] = val[0];
                    this.curr[1].zIndex = 0;
                    this.curr[1].isloadingBack = false;
                    this.startIdx = 1;
                } else {
                    this.startIdx = 0;
                }
            } else {
                this.startIdx = 0;
            };
            this.currTotal = val;
        }
    },
    methods: {
        _touchstartHandle: function _touchstartHandle(e) {
            this.currX = e.touches[0].clientX;
            this.startX = e.touches[0].clientX;
            this.moveDisX = 0;
            if (this.isTurnPhoto) {
                this.isTurnPhoto = false;
                this._updateCurrArr();
            };
            this.isTouch = true;
        },
        _touchmoveHandle: function _touchmoveHandle(e) {
            var moveX = e.touches[0].clientX;
            this.moveDisX = moveX - this.currX;
            this.currX = moveX;

            //主体的动作
            // front photo 角度变化
            var _angle = this.angle + this.moveDisX / 13;
            this.angle = this._limitInMaxAndMin(20, -20, _angle);
            this.frontStyle.transform = 'rotate3d(0, 0, 1, ' + this.angle + 'deg)';
            if (Math.abs(this.angle) < 6 || this.scale != 1 || this.opacity != 0 || this.cirOpacity != 1 || this.cirScale != 1 || this.cirXDis != this.containerW / 2) {
                //判断角度超过限制则除了front photo 其他动画暂停
                //back photo 缩放变化
                var _scale = moveX - this.startX >= 0 ? this.scale + this.moveDisX / 780 : this.scale - this.moveDisX / 780;
                this.scale = this._limitInMaxAndMin(1, .9, _scale);
                this.backStyle.transform = 'scale3d(' + this.scale + ', ' + this.scale + ', 1)';
                // back photo mask 透明度变化
                var _opacity = moveX - this.startX >= 0 ? this.opacity - this.moveDisX / 78 : this.opacity + this.moveDisX / 78;
                this.opacity = this._limitInMaxAndMin(1, 0, _opacity);

                // 计算side circle方向 以及动作
                this.circleVisible = moveX - this.startX >= 0 ? 'left' : 'right';
                this._sideCircleAni(moveX);
            }
        },
        _touchendHandle: function _touchendHandle(e) {
            this.isTouch = false;
            if (Math.abs(this.angle) >= 6 && !this.curr[0].isLoading) {
                if (this.startIdx >= this.currTotal.length - 1) {
                    this._turnToTheEnd();
                };
                this.isTurnPhoto = true;
                this._isChangePage(this.circleVisible == 'left' ? 'right' : 'left', this.curr[0]);
                this._photoisAni('turn');
            } else {
                this._photoisAni('resume');
            }
        },

        // side circle ani
        _sideCircleAni: function _sideCircleAni(moveX) {
            var _opacity = void 0,
                _xMoveDis = void 0,
                _scale = void 0;
            var isLeft = this.circleVisible === 'left';
            //透明度
            _opacity = isLeft ? this.cirOpacity + this.moveDisX / 78 : this.cirOpacity - this.moveDisX / 78;
            this.cirOpacity = this._limitInMaxAndMin(1, 0, _opacity);
            //距离
            _xMoveDis = isLeft ? this.cirXDis + this.moveDisX / .53 : this.cirXDis - this.moveDisX / .53;
            this.cirXDis = this._limitInMaxAndMin(this.containerW / 2, 0, _xMoveDis);
            //缩放
            _scale = isLeft ? this.cirScale + this.moveDisX / 87 : this.cirScale - this.moveDisX / 87;
            this.cirScale = this._limitInMaxAndMin(1, .1, _scale);

            if (isLeft) {
                this.rCircleSty = {
                    opacity: 0,
                    transform: 'scale3d(.1, .1, 1) translate3d(50%, 0, 0)',
                    right: 0
                };
                this.lCircleSty = {
                    opacity: this.cirOpacity,
                    transform: 'scale3d(' + this.cirScale + ', ' + this.cirScale + ', 1) translate3d(-50%, 0, 0)',
                    left: this.cirXDis + 'px'
                };
            } else {
                this.LCircleSty = {
                    opacity: 0,
                    transform: 'scale3d(.1, .1, 1) translate3d(-50%, 0, 0)',
                    left: 0
                };
                this.rCircleSty = {
                    opacity: this.cirOpacity,
                    transform: 'scale3d(' + this.cirScale + ', ' + this.cirScale + ', 1) translate3d(50%, 0, 0)',
                    right: this.cirXDis + 'px'
                };
            }
        },
        _photoisAni: function _photoisAni(type) {
            var _this = this;

            var self = this;
            if (type == 'turn') {
                var direction = 'left';
                var isTurn = 0;
                if (self.angle > 0) {
                    //right
                    direction = 'right';
                };
                //翻页时 的角度过渡
                self._easeoutAni(self.angle, direction == 'left' ? self.angle - 15 : self.angle + 15, 8, .1, function (ang, isEnd) {
                    self.angle = ang;
                    self.frontStyle.transform = 'rotate3d(0, 0, 1, ' + self.angle + 'deg)';
                    if (isEnd) {
                        isTurn++;
                        if (isTurn == 2) {
                            self._updateCurrArr();
                        }
                    }
                });
                // 翻页时 的透明度过渡
                self._easeoutAni(self.turnOpacity, 0, 8, .005, function (opa, isEnd) {
                    self.turnOpacity = opa;
                    self.frontStyle.opacity = self.turnOpacity;
                    if (isEnd) {
                        isTurn++;
                        if (isTurn == 2) {
                            self._updateCurrArr();
                        }
                    }
                });
                //翻页时 circle fadeOut
                self._easeoutAni(self.cirOpacity, 0, 8, .005, function (opa, isEnd) {
                    self.cirOpacity = opa;
                    var styles = self.circleVisible == 'left' ? self.lCircleSty : self.rCircleSty;
                    styles.opacity = self.cirOpacity;
                });
            } else if (type == 'resume') {
                //主体的过渡
                //角度
                self._easeoutAni(self.angle, 0, 6, .01, function (ang, isEnd) {
                    self.angle = ang;
                    self.frontStyle.transform = 'rotate3d(0, 0, 1, ' + self.angle + 'deg)';
                });
                //back photo 缩放
                self._easeoutAni(self.scale, .9, 8, .005, function (sca, isEnd) {
                    self.scale = sca;
                    self.backStyle.transform = 'scale3d(' + _this.scale + ', ' + _this.scale + ', 1)';
                });
                //back photo mask 透明度
                self._easeoutAni(self.opacity, 1, 8, .01, function (opa, isEnd) {
                    self.opacity = opa;
                });

                //circle
                self._circleEaseAni();
            }
        },
        _circleEaseAni: function _circleEaseAni() {
            var _this2 = this;

            var self = this;
            //back photo 缩放
            self._easeoutAni(self.cirScale, .1, 8, .005, function (sca, isEnd) {
                self.cirScale = sca;
                if (self.circleVisible == 'left') {
                    self.lCircleSty.transform = 'scale3d(' + _this2.cirScale + ', ' + _this2.cirScale + ', 1) translate3d(-50%, 0, 0)';
                } else {
                    self.rCircleSty.transform = 'scale3d(' + _this2.cirScale + ', ' + _this2.cirScale + ', 1) translate3d(50%, 0, 0)';
                }
            });
            //角度
            self._easeoutAni(self.cirXDis, 0, 8, 1, function (dis, isEnd) {
                self.cirXDis = dis;
                var styles = self.circleVisible == 'left' ? self.lCircleSty : self.rCircleSty;
                styles[self.circleVisible] = self.cirXDis + 'px';
            });
            //back photo mask 透明度
            self._easeoutAni(self.cirOpacity, 0, 8, .01, function (opa, isEnd) {
                self.cirOpacity = opa;
                var styles = self.circleVisible == 'left' ? self.lCircleSty : self.rCircleSty;
                styles.opacity = self.cirOpacity;
            });
        },
        _updateCurrArr: function _updateCurrArr() {
            this.isTurnPhoto = false;
            if (this.startIdx < this.currTotal.length) {
                this.curr.splice(0, 1);
                this.curr.push(this.currTotal[this.startIdx]);
                this.curr[0].zIndex = 1;
                this.curr[1].zIndex = 0;
                this.curr[1].isloadingBack = false;
                this.startIdx++;
            } else {
                var obj = void 0;
                if (this.curr[1].isLoading) {
                    obj = {
                        isLoading: false,
                        isloadingBack: true
                    };
                } else {
                    obj = {
                        isLoading: true,
                        isloadingBack: false
                    };
                };
                this.curr.splice(0, 1);
                this.curr.push(obj);
                this.curr[0].zIndex = 1;
                this.curr[1].zIndex = 0;
            };
            this._resetTransf();
        },
        _resetTransf: function _resetTransf() {
            this.angle = 0;
            this.turnOpacity = 1;

            this.scale = .9;
            this.opacity = 1;

            this.cirScale = .1;
            this.cirOpacity = 0;
            this.cirXDis = 0;

            this.frontStyle = {
                zIndex: 1,
                transform: '',
                opacity: 1
            };
            this.backStyle = {
                zIndex: 0,
                transformOrigin: '50% 50%',
                transform: 'scale3d(.9, .9, 1)'
            };
            this.lCircleSty = {
                opacity: 0,
                transform: 'scale3d(.1, .1, 1) translate3d(-50%, 0, 0)',
                left: 0
            };
            this.rCircleSty = {
                opacity: 0,
                transform: 'scale3d(.1, .1, 1) translate3d(50%, 0, 0)',
                right: 0
            };
        },
        _easeoutAni: function _easeoutAni(start, end, rate, limit, callback) {
            var self = this;
            var _end = end;
            if (start == end || typeof start != 'number') {
                return;
            };
            end = end || 0;
            rate = rate || 2;
            var step = function step() {
                if (self.isTouch) return;
                start = start + (end - start) / rate;
                if (Math.abs(start - _end) < limit) {
                    callback(end, true);
                    return;
                };
                callback(start, false);
                requestAnimationFrame(step);
            };
            step();
        },

        //limit fn
        _limitInMaxAndMin: function _limitInMaxAndMin(max, min, val) {
            if (val >= max) {
                return max;
            } else if (val <= min) {
                return min;
            } else {
                return val;
            }
        },

        //当前数组翻页快结束的自定义事件
        _turnToTheEnd: function _turnToTheEnd() {
            this.$emit('turnend', { state: 'Close to the end' });
        },
        _isChangePage: function _isChangePage(direction, item) {
            var itemObj = {};
            for (var key in item) {
                if (key != 'zIndex' && key != 'isloadingBack') {
                    itemObj[key] = item[key];
                }
            };
            this.$emit('change', {
                direction: direction,
                item: itemObj
            });
        },
        _winResized: function _winResized() {
            var self = this;
            //窗口变化时更新容器宽度
            window.addEventListener('resize', function (e) {
                self.containerW = self.$refs.photoSC.clientWidth;
            });
        }
    }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__photo_switching_vue__ = __webpack_require__(2);

// 导入组件 
var vuePhotoSwitching = {
    install: function install(Vue, options) {
        Vue.component(__WEBPACK_IMPORTED_MODULE_0__photo_switching_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__photo_switching_vue__["a" /* default */]);
    }
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(vuePhotoSwitching);
}

/* harmony default export */ __webpack_exports__["default"] = (vuePhotoSwitching);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_photo_switching_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3a15562b_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_photo_switching_vue__ = __webpack_require__(9);
function injectStyle (ssrContext) {
  __webpack_require__(3)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a15562b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_photo_switching_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3a15562b_hasScoped_true_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_photo_switching_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("35d497c2", content, true, {});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".photo-switching-container[data-v-3a15562b]{width:100%;height:100%;border-radius:7px;position:relative}.rotate-content[data-v-3a15562b]{transform-origin:50% 200%;-webkit-transform-origin:50% 200%;background:#ccc;will-change:transform}.back-photo-mask[data-v-3a15562b],.rotate-content[data-v-3a15562b]{position:absolute;left:0;top:0;width:100%;height:100%;border-radius:7px}.back-photo-mask[data-v-3a15562b]{background:rgba(0,0,0,.6)}.loading-card[data-v-3a15562b]{width:100%;height:100%;position:absolute;top:0;left:0;overflow:hidden;border-radius:7px}.side-circie[data-v-3a15562b]{width:70px;height:70px;position:absolute;z-index:20;text-align:center;line-height:70px;border-radius:50%;overflow:hidden;top:0;bottom:0;margin:auto 0}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(7)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"photoSC",staticClass:"photo-switching-container",on:{"touchstart":function($event){$event.preventDefault();_vm._touchstartHandle($event)},"touchmove":function($event){$event.preventDefault();_vm._touchmoveHandle($event)},"touchend":function($event){$event.preventDefault();_vm._touchendHandle($event)}}},[_vm._l((_vm.curr),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!item.isloadingBack),expression:"!item.isloadingBack"}],key:index,staticClass:"rotate-content animated",style:(item.zIndex == 1 ? _vm.frontStyle : _vm.backStyle)},[(item.zIndex == 0)?_c('div',{staticClass:"back-photo-mask",style:({opacity: _vm.opacity})}):_vm._e(),_vm._v(" "),_vm._t("default",null,{photo:item}),_vm._v(" "),(item.isLoading)?_c('div',{staticClass:"loading-card"},[_vm._t("loading")],2):_vm._e()],2)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.circleVisible  == 'left' && (_vm.curr.length == 2 && !_vm.curr[0].isLoading)),expression:"circleVisible  == 'left' && (curr.length == 2 && !curr[0].isLoading)"}],staticClass:"side-circie",style:(_vm.circleVisible == 'left' ? _vm.lCircleSty : '')},[_vm._t("l-circle")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.circleVisible  == 'right' && (_vm.curr.length == 2 && !_vm.curr[0].isLoading)),expression:"circleVisible  == 'right' && (curr.length == 2 && !curr[0].isLoading)"}],staticClass:"side-circie",style:(_vm.circleVisible == 'right' ? _vm.rCircleSty : '')},[_vm._t("r-circle")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// photo-switching.js